import type { IconSvgObject } from './types';

const RemoveCircleHalfDotIcon: IconSvgObject = [
  ["path", { d: "M12 2.00011C17.5228 2.00011 22 6.47726 22 12.0001C22 17.523 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.523 2 12.0001M8.909 2.48697C7.9 2.81459 6.96135 3.29826 6.12153 3.90952M3.90943 6.1216C3.29806 6.96158 2.81432 7.90042 2.4867 8.90963", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 12.0001L8 12.0001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RemoveCircleHalfDotIcon;
